var _path, _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddPlan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 30.0002L3.3335 36.6668V10.0002L15.0002 3.3335M15.0002 30.0002L26.6668 36.6668M15.0002 30.0002V3.3335M26.6668 36.6668L36.6668 30.0002V3.3335L26.6668 10.0002M26.6668 36.6668V10.0002M26.6668 10.0002L15.0002 3.3335",
    stroke: "#FF824D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33.998,
    cy: 33.485,
    r: 10.9496,
    transform: "rotate(45 33.998 33.485)",
    fill: "#FF824D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_681_55094)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.4173 33.4842H28.5778M33.9976 28.0645V38.904",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_681_55094"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.3294,
    height: 15.3294,
    fill: "white",
    transform: "translate(33.9976 22.6445) rotate(45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlan);
export default __webpack_public_path__ + "static/media/addPlan.1d10067acdb01c8992652b85a3470a71.svg";
export { ForwardRef as ReactComponent };